// Shared Aria constants.
//
// Extracted from the retired VoiceOnboardingFlow.jsx so the rest of the app
// (App.jsx, hooks/useVoiceCapture.js) can keep using the stored preferred-name
// key without importing a deleted component file.

/** localStorage key holding the user's preferred name (learned passively + via voice). */
export const ARIA_PREFERRED_NAME_KEY = 'aria_preferred_name';
